import React, { FC, useState, useEffect } from "react";
import { View, Modal } from "react-native";
import {
  useDeviceSize,
  CreateResponsiveStyle,
  DEVICE_SIZES,
} from "rn-responsive-styles";
import { AppColors } from "../../../utility/AppColors";
import { useNavigation } from "@react-navigation/native";
import ModalContainer from "./sign-up-common-components/ModalContainer";
import BackgroundImage from "./sign-up-common-components/BackGroundImage";
import SignUpForm from "./sign-up-common-components/SignUpForm";
import { decode } from "js-base64";
import { toast } from "react-toastify";

interface SignUpScreenModalProps {
  id?: string;
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  setModalType: (type: string) => void;
  setIsEmailConfirmationVisible: (show: boolean) => void;
  newUserName: string;
  setNewUserName: (string: string) => void;
  path: string;
  route: any;
}

const SignUpScreenModal: FC<SignUpScreenModalProps> = ({
  id = "signUp",
  showModal,
  setShowModal,
  setModalType,
  setIsEmailConfirmationVisible,
  route,
  newUserName,
  setNewUserName,
}) => {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [showLoader, setShowLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [directReferrerId, setDirectReferrerId] = useState("");
  const [isReferralEditable, setIsReferralEditable] = useState(true);
  console.log(route?.params?.path?.invite,"invite")

  useEffect(() => {
    if (route?.params?.path) {
      try {
        const queryString = route.params.path.split("/").pop();
        const inviteMatch = queryString.match(/invite=([^&]*)/);
        if (inviteMatch && inviteMatch[1]) {
          const invite = inviteMatch[1];
          const decodedInvite = JSON.parse(decode(invite));
          if (decodedInvite.referralCode) {
            setReferralCode(decodedInvite.referralCode);
          }
          if (decodedInvite.directReferrerId) {
            setDirectReferrerId(decodedInvite.directReferrerId);
          }
          setIsReferralEditable(false);
        }
      } catch (error) {
        console.error("Error decoding invite parameter:", error);
        toast.error("Invalid invite link");
      }
    }
  }, [route?.params?.path]);

  const onCloseClick = () => {
    setShowModal(false);
  };

  return (
    <View id={id}>
      <Modal
        animationType="fade"
        transparent={true}
        visible={showModal}
        onRequestClose={onCloseClick}
      >
        <ModalContainer>
          {/* <BackgroundImage deviceSize={deviceSize} styles={styles} /> */}
          <SignUpForm
            route={route}
            onClose={onCloseClick}
            showModal={showModal}
            setShowModal={setShowModal}
            styles={styles}
            email={email}
            setEmail={setEmail}
            // firstName={firstName}
            // setFirstName={setFirstName}
            // lastName={lastName}
            // setLastName={setLastName}
            username={newUserName}
            setUserName={setNewUserName}
            password={password}
            setPassword={setPassword}
            referralCode={referralCode}
            setReferralCode={setReferralCode}
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
            onCloseClick={onCloseClick}
            navigation={navigation}
            showLoader={showLoader}
            setShowLoader={setShowLoader}
            onSignUpSuccess={() => {
              setIsEmailConfirmationVisible(true);
              setShowModal(false);
            }}
            deviceSize={deviceSize}
            setModalType={setModalType}
            directReferrerId={directReferrerId}
            isReferralEditable={isReferralEditable}
          />

          {/*  signup popup */}

          {/* <SignupPopup
            visible={showPopup}
            onClose={() => setShowPopup(false)}
            onSignup={() => console.log("User signed up!")}
          /> */}
        </ModalContainer>
      </Modal>
    </View>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    tooltip: {
      backgroundColor: AppColors.appBlueColor_3A5175,
      top: 60,
      left: 0,
      right: 0,
      padding: 10,
      borderRadius: 8,
      borderWidth: 1,
      borderColor: AppColors.appBlueColor_3A5175,
      marginTop: 5,
      position: "absolute",
      width: "100%",
      zIndex: 1000,
      elevation: 1000,
    },
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      width: "50%",
      backgroundColor: AppColors.black_121212,
      paddingHorizontal: 30,
      marginHorizontal: 40,
      marginVertical: 50,
      alignSelf: "center",
      borderRadius: 12,
    },
    inputStyle: {
      backgroundColor: AppColors.appBlueColor_3A5175,
      marginBottom: 10,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "65%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 12,
      },
      inputStyle: {
        backgroundColor: AppColors.appBlueColor_3A5175,
        marginBottom: 10,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "70%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 12,
      },
      inputStyle: {
        backgroundColor: AppColors.appBlueColor_3A5175,
        marginBottom: 10,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "95%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 12,
      },
      inputStyle: {
        backgroundColor: AppColors.appBlueColor_3A5175,
        marginBottom: 10,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        width: "90%",
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: 30,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 12,
      },
      inputStyle: {
        backgroundColor: AppColors.appBlueColor_3A5175,
        marginBottom: 10,
      },
    },
  }
);

export default SignUpScreenModal;
